import * as yup from 'yup';
import * as utils from './utils';
import { Client } from '../entities';

export const schemaClient = yup.object<Partial<Client>>({
    name: yup.string().required('Ce champ est requis'),
    created_at: utils.toStringSchema(yup.date().nullable().transform(utils.emptyStringToNullTransform)),
    fk_centre_service_scolaire: yup.number().nullable(),
    nb_eleves_total: yup.number().nullable().integer('Ce champ doit contenir un nombre entier'),
    nb_avg_pedago: yup.number().nullable().integer('Ce champ doit contenir un nombre entier'),
    nb_avg_sortie: yup.number().nullable().integer('Ce champ doit contenir un nombre entier'),
    nb_sdg_total: yup.number().nullable().integer('Ce champ doit contenir un nombre entier'),
    fin_abonnement: utils.toStringSchema(yup.date().nullable().transform(utils.emptyStringToNullTransform)),
    notes: yup.string().nullable(),
    prefix: yup.string().nullable(),
    roles: yup.string().nullable(),
    groupe_age: yup.string().default(''),
    courriel: yup.string().email('Ce champ doit contenir une adresse courriel valide').default(''),
    telephone: yup.string().default(''),
    grandeur_gym: yup.string().default(''),
    nb_groupe_classe: yup.number().nullable().integer('Ce champ doit contenir un nombre entier'),
}) as yup.ObjectSchema<Partial<Client>>;
